import { render, staticRenderFns } from "./singleRepairContract.vue?vue&type=template&id=61d677c0&scoped=true"
import script from "./singleRepairContract.vue?vue&type=script&lang=js"
export * from "./singleRepairContract.vue?vue&type=script&lang=js"
import style0 from "./singleRepairContract.vue?vue&type=style&index=0&id=61d677c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d677c0",
  null
  
)

export default component.exports